import { StyledText } from './StyledText.tsx';

export const PositionedLabelBox = ({
  children,
  x,
  y,
  alignContent = 'end',
  justifyItems = 'center',
  textAlign = 'center',
}: {
  children: React.ReactNode;
  x: number;
  y: number;
  alignContent?: 'start' | 'end' | 'center';
  justifyItems?: 'start' | 'end' | 'center';
  textAlign?: 'left' | 'right' | 'center';
}) => {
  return (
    <foreignObject x={x} y={y} width={190} height={70}>
      <div
        style={{
          display: 'grid',
          width: '100%',
          height: '100%',
          alignContent: alignContent,
          justifyItems: justifyItems,
          direction: 'rtl',
          textAlign: textAlign,
        }}
      >
        <div
          style={{
            wordBreak: 'break-word',
            lineHeight: '20px',
          }}
        >
          <StyledText>{children}</StyledText>
        </div>
      </div>
    </foreignObject>
  );
};
